import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// @ts-ignore Ignore unused commented AuthGuard import
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AgrFilterModule, AgrPageToolbarModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { FieldDetailsComponent } from './field-details/field-details.component';
import { FieldsQuickEditComponent } from './fields-quick-edit/fields-quick-edit.component';

import { FieldsEffects } from './store/effects';

import { fieldsReducer } from './store/reducer';

@NgModule({
  declarations: [FieldsQuickEditComponent, FieldDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    AgrPageToolbarModule,
    AgrFilterModule,
    AgrDialogModule,
    AgrFormModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    MatSelectModule,
  ],
  providers: [provideState('fields', fieldsReducer), provideEffects(FieldsEffects)],
})
export class FieldsModule {}
